export enum DemoPages {
  ADVANCEDBUILDER = 'advancedBuilder',
  BASICBUILDER = 'basicBuilder',
  RUNSHOW = 'runShow',
  DASHBOARD = 'dashboard',
  FOLDERLIST = 'folderList',
}
